<template>
  <div>
    <a-card title="账号维度手续费配置" style="margin: 20px">
      <!-- 头部筛选区域 -->
      <div class="selected-box">
        <!-- 部门选择 -->
        <div class="selected-box-item">
          <span class="left-item">机构</span>
          <DepartmentChoose :department-code.sync="searchForm.departmentCode" @change="handleQuery"/>
        </div>
        <!-- 付款账号 -->
        <div class="selected-box-item">
          <span class="left-item">付款账号</span>
          <a-input v-model.trim="searchForm.accountNo" placeholder="请输入付款账号" @pressEnter="handleQuery"/>
        </div>


        <div class="selected-box-item" style="display: block">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 20px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="table-box">
        <div class="table-box-handle">
          <a-button type="primary" @click="handleAdd">
            <a-icon type="plus"/>
            新增配置
          </a-button>
        </div>
        <div class="table-main">
          <a-table size="small" :columns="columns" :data-source="tableData" :pagination="false" row-key="id" :loading="loading">


            <template slot="action" slot-scope="text, record">
              <a-button-group>
                <a-button type="link" @click="handleEdit(record)" size="small">
                  <a-icon type="edit"/>
                  编辑
                </a-button>
                <a-button type="link" @click="handleDelete(record)" size="small" style="color: #ff4d4f">
                  <a-icon type="delete"/>
                  删除
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页 -->
      <lcfs-pagination
          :page-no.sync="pagination.pageNo"
          :page-size.sync="pagination.pageSize"
          :total="total"
          :fn="fetchData"
      />
    </a-card>

    <!-- 新增/编辑弹窗 -->
    <a-modal :title="modalTitle" :visible="modalVisible" :width="800" :maskClosable="false" :confirm-loading="modalLoading" @ok="handleModalOk"
             @cancel="handleModalCancel">
      <a-form-model ref="formRef" :model="formData" :rules="formRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">

        <!-- 付款账户选择 -->
        <a-form-model-item label="付款账户" prop="accountNo">
          <WalletChooseDialog v-model="formData.accountName"   placeholder="请选择付款账户" @chooseDone="onAccountChosen"/>
          <WalletInfo v-if="formData.accountNo" :account-no="formData.accountNo" :account-name="formData.accountName" show-account-name :show-account-no="true"
                      style="margin-top: 8px"/>
        </a-form-model-item>


        <!-- 手续费账户选择（） -->
        <a-form-model-item label="手续费账户" prop="feeAccountNo">
          <WalletChooseDialog v-model="formData.feeAccountName"   placeholder="请选择手续费账户"
                              @chooseDone="onFeeAccountChosen"/>
          <WalletInfo v-if="formData.feeAccountNo" :account-no="formData.feeAccountNo" :account-name="formData.feeAccountName" show-account-name
                      :show-account-no="true" style="margin-top: 8px"
          />
        </a-form-model-item>

        <!-- 手续费规则选择（） -->
        <a-form-model-item label="手续费规则" prop="feeRuleNo">
          <a-select v-model="formData.feeRuleNo" placeholder="请选择手续费规则" allow-clear style="width: 100%" @change="handleFeeRuleChange">
            <a-select-option v-for="item in feeRuleList" :key="item.feeNo" :value="item.feeNo">
              {{ item.feeName }}
            </a-select-option>
          </a-select>
          <div v-if="formData.feeRuleName" style="color: #666; margin-top: 4px; font-size: 12px">
            规则名称：{{ formData.feeRuleName }}
          </div>
        </a-form-model-item>
        <a-form-model-item label="默认摘要" prop="remark">
          <a-input v-model="formData.remark" placeholder="请输入备注"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 删除确认弹窗 -->
    <a-modal
        title="确认删除"
        :visible="deleteModalVisible"
        @ok="handleDeleteConfirm"
        @cancel="deleteModalVisible = false"
    >
      <p>确定要删除这条手续费配置吗？</p>
      <p style="color: #ff4d4f; margin-top: 8px">删除后将无法恢复，请谨慎操作！</p>
    </a-modal>
  </div>
</template>

<script>
import DeptInfo from "@/view/components/DeptInfo.vue";
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import {handleChannelNo} from "@/utils/commonMethods";

export default {
  name: 'commonFeeAccCfg',
  components: {
    DepartmentChoose,
    WalletChooseDialog,
    WalletInfo,
    DeptInfo,
    LcfsPagination
  },
  data() {
    return {
      // 查询表单
      searchForm: {
        departmentCode: '',
        channelNo: '',
        appNo: '',
        accountNo: '',
        accountName: '',
        feeAccountNo: '',
      },

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,

      // 表格列配置
      columns: [
        {
          title: '序号',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => {
            return (this.pagination.pageNo - 1) * this.pagination.pageSize + index + 1;
          }
        },
        {
          title: '机构',
          dataIndex: 'departmentId',
          align: 'center',
          ellipsis: true,
          width: 120,
          customRender: (text) => {
            return <DeptInfo dept-id={text}/>
          },
        },
        {
          title: '渠道',
          dataIndex: 'channelNo',
          align: 'center',
          ellipsis: true,
          width: 80,
          customRender: (text) => {
            return handleChannelNo(JSON.parse(this.$session.getItem('coreCompanyList')), text, '1')
          },
        },

        {
          title: '付款账户',
          align: 'center',
          width: 200,
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.accountNo} accountName={record.accountName} showAccountName={true}/>);
          }
        },

        {
          title: '手续费账户',
          align: 'center',
          width: 200, customRender: (text, record) => {
            return (<WalletInfo accountNo={record.feeAccountNo} accountName={record.feeAccountName} showAccountName={true}/>);
          }
        },
        {
          title: '服务费规则',
          dataIndex: 'feeRuleName',
          key: 'feeRuleName',
          align: 'center'
        },
        {
          title: '服务费规则编号',
          dataIndex: 'feeRuleNo',
          key: 'feeRuleNo',
          align: 'center'
        },
        {
          title: '默认摘要',
          dataIndex: 'remark',
          key: 'remark',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 弹窗相关
      modalVisible: false,
      modalLoading: false,
      modalTitle: '新增手续费配置',
      deleteModalVisible: false,

      // 表单数据
      formData: {
        id: undefined,
        departmentCode: '',
        channelNo: '',
        appNo: '',
        accountNo: '',
        accountName: '',
        feeAccountNo: '',
        feeAccountName: '',
        feeRuleNo: '',
        feeRuleName: ''
      },

      // 表单验证规则
      formRules: {

        accountNo: [
          {required: true, message: '请选择付款账户', trigger: 'blur'}
        ],
        feeAccountNo: [
          {required: true, message: '请选择手续费账户', trigger: 'blur'}
        ],
        feeRuleNo: [
          {required: true, message: '请选择手续费规则', trigger: 'blur'}
        ]
      },

      // 手续费规则列表
      feeRuleList: [],

      // 当前操作的数据
      currentRecord: null
    };
  },
  created() {
    this.fetchData();
    this.loadFeeRules();
  },
  computed: {},
  watch: {},
  methods: {
    // 加载手续费规则
    async loadFeeRules() {
      try {
        const res = await this.api.getCommisionFeeRuleApi({});
        if (res.code === 200) {
          this.feeRuleList = res.data.filter(item => item.feeType !== '4');
        }
      } catch (error) {
        console.error('加载手续费规则失败:', error);
      }
    },

    // 获取表格数据
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        };

        const res = await this.api.feeAccCfg.page(params);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 查询
    handleQuery() {
      this.pagination.pageNo = 1;
      this.fetchData();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        departmentCode: '',
        channelNo: '',
        appNo: '',
        accountNo: '',
        accountName: '',
        feeAccountNo: '',
      };
      this.pagination.pageNo = 1;
      this.fetchData();
    },

    // 新增
    handleAdd() {
      this.modalTitle = '新增手续费配置';
      this.formData = {
        id: undefined,
        departmentCode: '',
        channelNo: '',
        appNo: '',
        accountNo: '',
        accountName: '',
        feeAccountNo: '',
        feeAccountName: '',
        feeRuleNo: '',
        feeRuleName: '',
        remark: ''
      };

      this.modalVisible = true;
    },

    // 编辑
    async handleEdit(record) {
      this.modalTitle = '编辑手续费配置';
      this.currentRecord = record;

      try {
        const res = await this.api.feeAccCfg.detail({id: record.id});
        if (res.code === 200) {
          this.formData = {
            id: res.data.id,
            departmentCode: res.data.departmentCode,
            channelNo: res.data.channelNo,
            appNo: res.data.appNo,
            accountNo: res.data.accountNo,
            accountName: res.data.accountName,
            feeAccountNo: res.data.feeAccountNo || '',
            feeAccountName: res.data.feeAccountName || '',
            feeRuleNo: res.data.feeRuleNo || '',
            feeRuleName: res.data.feeRuleName || '',
            remark: res.data.remark || '',

          };


          this.modalVisible = true;
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      }
    },

    // 删除
    handleDelete(record) {
      this.currentRecord = record;
      this.deleteModalVisible = true;
    },

    // 确认删除
    async handleDeleteConfirm() {
      try {
        const res = await this.api.feeAccCfg.delete({id: this.currentRecord.id});
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
          this.$message.error(res.info);
        }
      } catch (error) {
        console.error('删除失败:', error);
        this.$message.error('删除失败');
      } finally {
        this.deleteModalVisible = false;
        this.currentRecord = null;
      }
    },

    // 选择付款账户
    onAccountChosen(wallet) {
      this.formData.accountNo = wallet.accountNo;
      this.formData.accountName = wallet.accountName;
    },

    // 选择手续费账户
    onFeeAccountChosen(wallet) {
      this.formData.feeAccountNo = wallet.accountNo;
      this.formData.feeAccountName = wallet.accountName;
    },

    // 手续费规则变更
    handleFeeRuleChange(value) {
      const rule = this.feeRuleList.find(item => item.feeNo === value);
      this.formData.feeRuleName = rule ? rule.feeName : '';
    },


    // 弹窗确认
    async handleModalOk() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;

        this.modalLoading = true;
        try {
          console.log("this.formData", this.formData)
          const res =  this.formData.id ? await this.api.feeAccCfg.update(this.formData): await this.api.feeAccCfg.add(this.formData);

          if (res.code === 200) {
            this.$message.success(this.formData.id ? '修改成功' : '新增成功');
            this.modalVisible = false;
            this.fetchData();
          } else {
            this.$message.error(res.info);
          }
        } catch (error) {
          console.error('操作失败:', error);
          this.$message.error('操作失败');
        } finally {
          this.modalLoading = false;
        }
      });
    },

    // 弹窗取消
    handleModalCancel() {
      this.modalVisible = false;
      this.$refs.formRef.clearValidate();
    }
  }
};
</script>

<style lang="less" scoped>
.selected-box {
  display: flex;
  flex-wrap: wrap;

  /deep/ .selected-box-item {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    width: 280px;
    margin-bottom: 20px;
    align-items: center;

    .left-item {
      margin-right: 15px;
      min-width: 80px;
      text-align: right;
    }

    .ant-input,
    .ant-select {
      width: 200px;
    }
  }
}

.table-box {
  margin-top: 20px;

  .table-box-handle {
    margin-bottom: 20px;
  }
}
</style>